// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store/store'
import { mapGetters } from 'vuex'
import Promise from 'promise-polyfill';

Vue.config.productionTip = false

// To add to window
if (!window.Promise) {
  window.Promise = Promise;
}

if (window.performance) {
  var timeSincePageLoad = Math.round(performance.now());
  if(window.console){
    console.log("page loading took "+ timeSincePageLoad);
  }
}

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store: store,
  components: {
    App
  },
  template: '<App/>',
  created: function () {
    this.$store.dispatch('ResetDate');
    this.$store.dispatch('ResetServices');
    this.$store.dispatch('Initialize', vv.boot_data);
    this.$store.dispatch('InitializeState');
    if(vv.boot_data.ClientPractices.length==1){
        var selectedPractice =vv.boot_data.ClientPractices[0];
        this.$store.dispatch('SetRequestedServices', selectedPractice.RequestedServices);
        this.$store.dispatch('PracticeSelected', selectedPractice);
        this.$store.dispatch('InitializeSpecies', selectedPractice);
        this.$router.push({ name: 'PetOwnerDetails' })
    }
  }
})



// WEBPACK FOOTER //
// ./src/main.js